/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box, Center, HStack, ScrollView, Skeleton } from 'native-base';
import { H2 } from '~/shared/Typography';
import ItemCard, { ItemCardSkeleton } from '~/shared/ItemCard';
import { BuilderRewards } from '../Reward';
import { useGeneralStyles, useRewardsStyles } from '~/shared/styles';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';

export type RewardSliderBoxProps = {
    rewards: BuilderRewards;
    redeemIsLoading: boolean;
    handleAcceptRedeemReward: (id: number, title?: string) => void;
}

const RewardSliderBox = ({ rewards, redeemIsLoading, handleAcceptRedeemReward }: RewardSliderBoxProps) => {

    const {
        text
    } = useRewardsStyles();
    const gStyle = useGeneralStyles();
    const {
        rewards: rewardsSettings,
        style: { rewards: { rewardSliderBox = {}, rewardItemCaption = {} } = {} } = {}
    } = useAppSettings();

    const rewarsCount = Object.keys(rewards).length;

    return (
        <Box w={'clamp(320px, 100vw, 480px)'}>
            <Center>
                {
                    Object.entries(rewards).map(([key, value], index) => {

                        const processKey = key.split('-')[1];
                        const isCentered = value.length > 1 ? false : rewardsSettings?.showInCenter;
                        
                        return (
                            <Box
                                key={key}
                                overflowX='hidden'
                                w={'100%'}
                                {...rewardSliderBox}
                                borderBottomWidth={index === (rewarsCount - 1) ? 0 : rewardSliderBox.borderBottomWidth}
                            >
                                <H2
                                    color={text}
                                    px={4}
                                    text={'rewards.title_points_rewards'}
                                    textValues={[`${processKey}`]}
                                    textAlign={isCentered ? 'center' : 'left'}
                                />
                                <Box
                                    key={key}
                                    flexDirection='row'
                                    bg={gStyle.section_background}
                                    mb={4}
                                    overflowX='auto'
                                    py={4}
                                    w={'100%'}
                                    justifyContent={isCentered ? 'center' : 'normal'}
                                >
                                    {
                                        value.map(reward => {

                                            return (
                                                <Box key={reward?.id} ml={isCentered ? 0 : 5}>
                                                    <ItemCard
                                                        testID={`reward-box`}
                                                        loadingComponent={false}
                                                        handleCallback={handleAcceptRedeemReward}
                                                        isDisabled={redeemIsLoading}
                                                        id={reward.id}
                                                        title={reward.name}
                                                        imageUrl={reward.images.length > 0 ? reward.images[0].url : undefined}
                                                        captionStyle={rewardItemCaption}
                                                    />
                                                </Box>
                                            );
                                        })
                                    }
                                </Box>
                            </Box>
                        );
                    })
                }
            </Center>
        </Box>
    );
};

export const RewardSliderBoxSkeleton = () => {

    const gStyle = useGeneralStyles();

    return (
        <Center w="100%">
            <Skeleton.Text lines={1} alignItems="center" pl={4} pr={10} py={5} />
            <HStack bg={gStyle.section_background}>
                <ItemCardSkeleton />
                <ItemCardSkeleton />
            </HStack>
        </Center>
    );
};


export default RewardSliderBox;
